import type { HTMLAttributes } from 'react';

type Tone = 'info' | 'wood' | 'ippc' | 'success' | 'warning' | 'danger' | 'muted';

interface StatusTagProps extends HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
  tone?: Tone;
}

// 竖条颜色 · 对应工业面板 LED 指示灯
const barClasses: Record<Tone, string> = {
  info:    'bg-info',
  wood:    'bg-wood-500',
  ippc:    'bg-ippc-500',
  success: 'bg-success',
  warning: 'bg-warning',
  danger:  'bg-danger',
  muted:   'bg-oak-300',
};

/**
 * 签名动作 C · LED 竖条状态徽标
 *
 * 取代圆角 pill 糖果徽章。2×14px 竖条 + 文字，像工业面板指示灯。
 * 详见 DESIGN.md §9.3。
 *
 * 语义建议：
 *   info    — 待审图 / 待确认
 *   wood    — 生产中 / 锯切中 / 组装中（主流程进行中）
 *   ippc    — 熏蒸中 / 已熏蒸 / 待出证书（合规类）
 *   success — 已完工 / 已装柜
 *   warning — 临期
 *   danger  — 已逾期 / 异常
 *   muted   — 已取消 / 归档
 */
export default function StatusTag({ children, tone = 'muted', className = '', ...rest }: StatusTagProps) {
  return (
    <span
      {...rest}
      className={`inline-flex items-center gap-2 whitespace-nowrap text-sm text-walnut-900 ${className}`}
    >
      <span className={`inline-block h-3.5 w-[3px] flex-shrink-0 ${barClasses[tone]}`} aria-hidden />
      <span>{children}</span>
    </span>
  );
}
